import { startup } from 'components/app'
import CourseList from './course/index'

startup({
	index: CourseList
})
